import React, { useState } from 'react';
import './Header.css';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
        setIsMenuOpen(false);
    };

    return (
        <header className="header">
            <div className="container">
                <div className="header-inner">
                    <div className="logo">
                        <h1>Strefa<span>Napędu</span></h1>
                    </div>

                    <div className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
                        <ul>
                            <li><button onClick={() => scrollToSection('home')}>Strona główna</button></li>
                            <li><button onClick={() => scrollToSection('services')}>Usługi</button></li>
                            <li><button onClick={() => scrollToSection('about')}>O nas</button></li>
                            <li><button onClick={() => scrollToSection('video')}>Realizacje</button></li>
                            <li><button onClick={() => scrollToSection('contact')}>Kontakt</button></li>
                        </ul>
                    </div>

                    <div className="header-phone">
                        <a href="tel:+48888329544" className="btn btn-primary">
                            <i className="fas fa-phone-alt"></i> 888 329 544
                        </a>
                    </div>

                    <div className="mobile-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                        <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;